module.exports = __webpack_public_path__ + "img/lian.a4cb2d0b.png";